import { FormControlLabel, Grid, Radio, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React, { useState, useEffect } from 'react';
import { Frequency } from 'rrule';
import { MONTHS, repeatEndItemList, OnWeekOfList, DAYS } from '.';
import FuelAutoComplete from '../../fuel-autocomplete';
import RepeatEnd from './RepeatEnd';

const Yearly = ({ form, onFormChange }) => {
  const [selectedRepeat, setSelectedRepeat] = useState({
    id: 'never',
    name: 'Never',
  });
  const [selectedOnWeekOf, setselectedOnWeekOf] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');

  const handleRepeatChange = (value) => {
    setSelectedRepeat(value);
  };
  const handleOnWeekChange = (value) => {
    setselectedOnWeekOf(value);
    fieldOnChange('rrule.bysetpos', value.id)
  };
  const handleOnDayChange = (value) => {
    setSelectedDay(value);
    fieldOnChange('rrule.byweekday', value.id)
  };
  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    form.setValue('rrule.bymonth', value.id);
    onFormChange(form);
  };

  const fieldOnChange = (field, value) => {
    form.setValue(field, value);
    if (onFormChange) {
      // console.log('update');
      onFormChange(form);
    }
  };

  const handleRadioClick = (e, field) => {
    form.setValue('monthMode', e.target.value);
    if (e.target.value === 'onMonthDay') {
      form.setValue('rrule.bysetpos', null);
    } else {
      form.setValue('rrule.bymonthday', '');
    }
    onFormChange(form);
  };

  useEffect(() => {
    const rrule = form.getValues('rrule');
    if (rrule && rrule.freq === Frequency.YEARLY && form.getValues('rrule.bymonth')) {
      const month = form.getValues('rrule.bymonth');
      setSelectedMonth(MONTHS[month - 1]);
    }
  }, [form]);

  const [untilValue, setUntilValue] = useState(new Date());
  return (
    <>
      <Grid item xs={6}>
        <FuelAutoComplete
          id="months-select"
          items={MONTHS}
          itemText="name"
          itemKey="id"
          labelText="Repeat on"
          placeHolderText=""
          controlWidth={250}
          multiSelect={false}
          labelPaddingTop="-5px"
          onChange={handleMonthChange}
          defaultValue={selectedMonth}
        />
      </Grid>
      <RepeatEnd form={form} onFormChange={onFormChange} />
      <Grid item xs={2}>
        <FormControlLabel
          control={
            <Radio onChange={handleRadioClick} value="onMonthDay" checked={form.getValues('monthMode') === 'onMonthDay'} />
          }
          label="Day"
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          variant="outlined"
          type="number"
          InputProps={{
            inputProps: {
              max: 31,
              min: 1,
            },
          }}
          fullWidth
          size="small"
          value={form.getValues('rrule.bymonthday')}
          onChange={(e) => fieldOnChange('rrule.bymonthday', e.target.value)}
        />
      </Grid>
      <Grid item xs={6}></Grid>
      <Grid item xs={2}>
        <FormControlLabel
          control={<Radio onChange={handleRadioClick} value="onWeek" checked={form.getValues('monthMode') === 'onWeek'} />}
          label=""
        />
      </Grid>
      <Grid item xs={3}>
        <FuelAutoComplete
          id="repeat-select"
          items={OnWeekOfList}
          itemText="name"
          itemKey="id"
          labelText=""
          placeHolderText=""
          multiSelect={false}
          labelPaddingTop="-5px"
          defaultValue={selectedOnWeekOf}
          onChange={handleOnWeekChange}
        />
      </Grid>
      <Grid item xs={3}>
        <FuelAutoComplete
          id="repeat-select"
          items={DAYS}
          itemText="name"
          itemKey="id"
          labelText=""
          placeHolderText=""
          multiSelect={false}
          labelPaddingTop="-5px"
          onChange={handleOnDayChange}
          defaultValue={selectedDay}
        />
      </Grid>
    </>
  );
};

export default Yearly;
